<template>
  <div>
    <Navbar v-if="this.$route.name == 'mailsettings'"/>
    <Breadcrumb v-if="this.$route.name == 'mailsettings'" />
    <b-tabs class="col-12 px-0 mx-0 mt-2" content-class="mt-3">
      <b-tab lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="envelope-open-text"
            />
            Mail to new user
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <DefaultMailNewUser />
        </b-card>
      </b-tab>
      <b-tab lazy>
        <template v-slot:title>
          <div class="col-12 text-center">
            <fa-icon
              class="mr-2"
              name="envelope-open-text"
            />
            Invoice notification to admin
          </div>
        </template>
        <b-card no-body class="border-0 mx-0 px-0 pl-0 pr-0 col-12">
          <DefaultMailNewInvoice />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="tasks"
            />Mail Servers
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_mailservers" />
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="search"
            />Mail queue
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <Maintenance tablename="g_mailqueue" noedit="true"/>
        </b-card>
      </b-tab>
      <b-tab lazy class="px-0 col-12 border-0">
        <template v-slot:title>
          <div class="text-center">
            <fa-icon
              class="mr-2"
              name="cog"
            />Test mail addresses
          </div>
        </template>
        <b-card class="border-0 mx-auto px-0 col-12">
          <TestMailAddresses />
        </b-card>
      </b-tab>      
    </b-tabs>
  </div>
</template>
<script>
import DefaultMailNewUser from './DefaultMailNewUser';
import DefaultMailNewInvoice from './DefaultMailNewInvoice';
import Maintenance from './Maintenance';
import TestMailAddresses from './TestMailAddresses.vue';
import Navbar from './Navbar.vue';
import Breadcrumb from './Breadcrumb.vue';
export default {
  name: 'MailSettings',
  mounted() {
    this.prefs_get();
  },
  components: {
    DefaultMailNewUser,
    DefaultMailNewInvoice,
    Maintenance,
    TestMailAddresses,
    Navbar,
    Breadcrumb,
},
  data: function() {
    return {
      gdqreport_price: 0,
      gdq_vat: 0,
    }
  },
  methods: {
    savepref(key,value) {
      if (key.indexOf('_date') != -1) {
        value = this.format_date(value);
      }
      this.$store.dispatch('syspref_save', { key: key,value: value });
    },
    prefs_get() {
      this.$store.dispatch('syspref_fetch', { key: 'gdqreport_price' })
      .then((resp) => {
        this.gdqreport_price = resp.data.value;
        this.$store.dispatch('syspref_fetch', { key: 'gdq_vat' })
        .then((resp) => {
          this.gdq_vat = resp.data.value;
        });
      });
    },
  },
}
</script>
<style>
</style>
